import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-footer" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomModal',
  props: {
    show: { type: Boolean },
    closeOnOutsideClick: { type: Boolean },
    onClose: { type: Function }
  },
  emits: ['update:show'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

function closeModal() {
  if (props.onClose) {
    try {
      props.onClose();
    } catch (error) {
      console.error('Error in onClose handler:', error);
    }
  }
  emits('update:show', false);
}

function handleOutsideClick() {
  if (props.closeOnOutsideClick) closeModal();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop",
          onClick: handleOutsideClick
        }, [
          _createElementVNode("div", {
            class: "modal-container",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "left-button"),
              _createElementVNode("button", {
                class: "close-button",
                onClick: closeModal,
                role: "button"
              }, _toDisplayString(_ctx.$t('common.actions.close')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})